import { useState } from 'react';
import loadingSvg from '../assets/loading.svg';
import {
  OutOfStock,
  ProductQuantityIncrementProps,
} from '../interface/interface';

const ProductQuantityIncrement = (props: ProductQuantityIncrementProps) => {
  const {
    productCode,
    orderedQuantity,
    productOutOfStock,
    maxQuantity,
    addProductToCart,
    removeProductFromCart,
    minimalist,
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div
      className={
        !minimalist
          ? 'py-2 px-3 bg-white border border-secondary-cornflowerblue-500 rounded-lg'
          : ''
      }
    >
      <div
        className="w-full flex justify-center items-center gap-x-3"
        data-hs-input-number
      >
        {!minimalist && (
          <div>
            <span className="text-sm">
              {'Max Qty: '}
              {maxQuantity ? maxQuantity : `N/A`}
            </span>
          </div>
        )}
        <div className="flex justify-end items-center gap-x-1.5">
          <button
            type="button"
            className="w-6 h-6 inline-flex justify-center items-center 
            gap-x-2 text-sm font-medium rounded-full border 
            border-secondary-cornflowerblue-500 bg-white text-gray-800 shadow-sm hover:bg-gray-50 
            disabled:opacity-50 disabled:pointer-events-none"
            onClick={async () => {
              setLoading(true);
              await removeProductFromCart(productCode);
              setLoading(false);
            }}
          >
            <svg
              className="flex-shrink-0 w-3.5 h-3.5"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14" />
            </svg>
          </button>
          {loading ? (
            <img height="20px" width="20px" src={loadingSvg} alt="Loading" />
          ) : (
            <span className="mx-1 text-sm">{orderedQuantity}</span>
          )}
          <button
            type="button"
            className="w-6 h-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-full 
            border border-secondary-cornflowerblue-500 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 
            disabled:cursor-not-allowed"
            disabled={
              productOutOfStock ===
                OutOfStock.orderedQuantityExceedsWithNoSubs ||
              productOutOfStock === OutOfStock.withNoSubs
            }
            onClick={async () => {
              setLoading(true);
              await addProductToCart(productCode);
              setLoading(false);
            }}
          >
            <svg
              className="flex-shrink-0 w-3.5 h-3.5"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductQuantityIncrement;
